/**
 * Volume Tiers - SEO optimized
 * Custom UI with Regios DOPP API for volume discounts
 */
(function() {
  'use strict';

  /* Evita doppia esecuzione se il snippet è renderizzato più volte */
  if (window.__volumeTiersInitialized) return;
  window.__volumeTiersInitialized = true;

  /* Salva i tier globalmente per il price controller */
  window.__volumeTiers = [];

  var container = document.querySelector('[data-volume-tiers]');
  var qtyInc = container ? parseInt(container.dataset.qtyIncrement || '1', 10) : 1;
  var TEST_QTYS = [];
  for (var i = qtyInc; i <= 100; i += qtyInc) {
    TEST_QTYS.push(i);
  }
  var MAX_DISPLAY = 7;
  var lastVariantId = null;

  /* Cache del product JSON per evitare fetch ripetute */
  var productJsonCache = null;

  function getVariantId() {
    var vid = new URLSearchParams(location.search).get('variant');
    if (vid) return parseInt(vid, 10);
    var inp = document.querySelector('input[name="id"]');
    if (inp && inp.value) return parseInt(inp.value, 10);
    return null;
  }

  function isAPIReady() {
    return !!(
      window.RegiosDOPP &&
      window.RegiosDOPP.api &&
      window.RegiosDOPP.api.v0 &&
      window.RegiosDOPP.api.v0.productPage &&
      typeof window.RegiosDOPP.api.v0.productPage.calculateDiscountedPrices === 'function'
    );
  }

  function fmt(amount) {
    var s = amount.toFixed(2).replace('.', ',');
    var p = s.split(',');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '\u20AC' + p[0] + ',' + p[1];
  }

  function esc(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /**
   * Aggiorna data-variant-price dalla cache o fetch product.js
   */
  function updateVariantPriceAttribute(variantId, callback) {
    function applyPrice(variants) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) {
          var pi = document.querySelector('product-info');
          if (pi) pi.dataset.variantPrice = variants[i].price;
          if (callback) callback();
          return;
        }
      }
      if (callback) callback();
    }

    if (productJsonCache) {
      applyPrice(productJsonCache);
      return;
    }

    var path = location.pathname.split('?')[0];
    fetch(path + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        productJsonCache = data.variants || [];
        applyPrice(productJsonCache);
      })
      .catch(function() {
        if (callback) callback();
      });
  }

  /**
   * Legge il prezzo base corrente dalla variante selezionata.
   */
  function getBaseCents() {
    var pi = document.querySelector('product-info');
    var cents = pi ? parseInt(pi.dataset.variantPrice || '0', 10) : 0;
    if (cents > 0) return cents;

    var vid = getVariantId();
    if (!vid || !productJsonCache) return 0;

    for (var i = 0; i < productJsonCache.length; i++) {
      if (String(productJsonCache[i].id) === String(vid)) {
        cents = productJsonCache[i].price;
        if (pi) pi.dataset.variantPrice = cents;
        return cents;
      }
    }
    return 0;
  }

  /**
   * Analizza i risultati Regios per capire il pattern degli sconti.
   * Restituisce un array di oggetti {qty, pct} per ogni risultato.
   */
  function analyzeResults(results) {
    var analysis = [];
    for (var r = 0; r < results.length; r++) {
      var item = results[r];
      var badgePct = 0;
      if (item.res.badge && item.res.badge.html) {
        var match = item.res.badge.html.match(/(\d+)%/);
        if (match) badgePct = parseInt(match[1], 10);
      }
      analysis.push({ qty: item.qty, pct: badgePct });
    }
    return analysis;
  }

  /**
   * Trova la qty dove lo sconto diventa "continuo" (tutte le qty consecutive hanno sconto).
   * Restituisce la qty di inizio della soglia continua, o 0 se non esiste.
   */
  function findContinuousThreshold(analysis) {
    var threshold = 0;
    for (var i = analysis.length - 1; i >= 0; i--) {
      if (analysis[i].pct > 0) {
        threshold = analysis[i].qty;
      } else {
        break;
      }
    }
    return threshold;
  }

  async function discoverTiers() {
    var api = window.RegiosDOPP.api.v0;
    var containers = document.querySelectorAll('[data-volume-tiers]');
    if (!containers.length) return;

    var vid = getVariantId();
    lastVariantId = vid;

    var baseCents = getBaseCents();

    try {
      var promises = [];
      for (var i = 0; i < TEST_QTYS.length; i++) {
        (function(qty) {
          var opts = { quantity: qty };
          if (vid) opts.variantId = vid;
          promises.push(
            api.productPage.calculateDiscountedPrices(opts)
              .then(function(res) { return { qty: qty, res: res }; })
          );
        })(TEST_QTYS[i]);
      }

      var results = await Promise.all(promises);
      results.sort(function(a, b) { return a.qty - b.qty; });

      var basePrice = results[0].res.regularPrice.amount / results[0].qty;

      /* Analizza il pattern degli sconti */
      var analysis = analyzeResults(results);
      var continuousFrom = findContinuousThreshold(analysis);

      /* Costruisci i tier */
      var tiers = [];
      var lastPct = -1;

      for (var r = 0; r < results.length; r++) {
        var item = results[r];
        var badgePct = analysis[r].pct;

        /* Calcola prezzo unitario come Shopify: floor sullo sconto */
        var unit;
        if (badgePct > 0 && baseCents > 0) {
          var discountAmount = Math.floor(baseCents * badgePct / 100);
          unit = (baseCents - discountAmount) / 100;
        } else {
          if (baseCents > 0) {
            unit = baseCents / 100;
          } else {
            unit = Math.round((item.res.salePrice.amount / item.qty) * 100) / 100;
          }
        }

        if (lastPct === -1) {
          /* Primo tier (prezzo base, sempre) */
          tiers.push({ minQty: item.qty, unitSale: unit, unitRegular: basePrice, pct: badgePct });
          lastPct = badgePct;
        } else if (badgePct > 0) {
          if (continuousFrom > 0 && item.qty > continuousFrom && badgePct === lastPct) {
            continue;
          }
          tiers.push({ minQty: item.qty, unitSale: unit, unitRegular: basePrice, pct: badgePct });
          lastPct = badgePct;
        }
      }

      /* Salva TUTTI i tier globalmente per il price controller */
      window.__volumeTiers = tiers;

      /* Notifica il price controller che i tier sono pronti */
      document.dispatchEvent(new CustomEvent('volume-tiers:ready', { detail: { tiers: tiers } }));

      /* Nessuno sconto volume: nascondi tutto */
      if (tiers.length <= 1) {
        containers.forEach(function(c) {
          c.style.display = 'none';
          var g = c.querySelector('[data-volume-tiers-grid]');
          if (g) g.innerHTML = '';
        });
        return;
      }

      /* Limita a MAX_DISPLAY */
      var displayTiers = tiers;
      if (tiers.length > MAX_DISPLAY) {
        var head = tiers.slice(0, MAX_DISPLAY - 1);
        head.push(tiers[tiers.length - 1]);
        displayTiers = head;
      }

      var lastTierGetsPlus = continuousFrom > 0;

      containers.forEach(function(ctr) {
        var grid = ctr.querySelector('[data-volume-tiers-grid]');
        if (!grid) return;
        renderTiers(grid, displayTiers, lastTierGetsPlus);
        ctr.style.display = '';
        bindEvents(ctr);
      });

    } catch (err) {
      containers.forEach(function(c) { c.style.display = 'none'; });
    }
  }

  function renderTiers(grid, tiers, lastTierGetsPlus) {
    var html = '';
    for (var t = 0; t < tiers.length; t++) {
      var tier = tiers[t];
      var isFirst = (t === 0);
      var isLast = (t === tiers.length - 1);
      var label = 'x' + tier.minQty + (isLast && lastTierGetsPlus ? '+' : '');
      var saleF = fmt(tier.unitSale);
      var save = tier.pct || Math.round((1 - tier.unitSale / tier.unitRegular) * 100);
      var active = isFirst ? ' volume-tiers__card--active' : '';

      /* Nome accessibile: contiene il testo visibile ("x3") come richiede il criterio
         "Label in Name", seguito dal contesto che a schermo è dato solo dal layout. */
      var qtyWords = tier.minQty === 1 ? '1 confezione' : tier.minQty + ' confezioni';
      if (isLast && lastTierGetsPlus) qtyWords = tier.minQty + ' confezioni o più';
      var ariaLabel = label + ': ' + qtyWords + ', ' + saleF + ' a pezzo';
      if (save > 0) ariaLabel += ', sconto ' + save + '%';

      html += '<button type="button" class="volume-tiers__card' + active + '" data-tier-btn data-tier-qty="' + tier.minQty + '"';
      html += ' aria-label="' + esc(ariaLabel) + '" aria-pressed="' + (isFirst ? 'true' : 'false') + '">';
      html += '<span class="volume-tiers__top-row">';
      html += '<span class="volume-tiers__label">' + label + '</span>';
      if (save > 0) {
        html += '<span class="volume-tiers__badge">-' + save + '%</span>';
      }
      html += '</span>';
      html += '<span class="volume-tiers__price"><strong>' + saleF + '</strong>';
      html += '<span class="volume-tiers__price-unit"> / pezzo</span></span>';
      html += '</button>';
    }
    grid.innerHTML = html;
  }

  function bindEvents(ctr) {
    var buttons = ctr.querySelectorAll('[data-tier-btn]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var qty = parseInt(btn.getAttribute('data-tier-qty'), 10);

        /* Sync stato attivo su TUTTI i container volume-tiers */
        document.querySelectorAll('[data-volume-tiers]').forEach(function(c) {
          c.querySelectorAll('[data-tier-btn]').forEach(function(b) {
            var isSelected = parseInt(b.getAttribute('data-tier-qty'), 10) === qty;
            b.classList.toggle('volume-tiers__card--active', isSelected);
            b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });
        });

        updateQty(qty);
      });
    });
  }

  function updateQty(qty) {
    var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    document.querySelectorAll('input[name="quantity"]').forEach(function(input) {
      setter.call(input, qty);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function refresh() {
    var newVid = getVariantId();
    if (newVid && newVid !== lastVariantId && isAPIReady()) {
      updateVariantPriceAttribute(newVid, function() {
        discoverTiers();
      });
    }
  }

  function startVariantListeners() {
    document.querySelectorAll('input[name="id"]').forEach(function(hiddenInput) {
      new MutationObserver(function() { refresh(); })
        .observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
    });

    document.addEventListener('change', function(e) {
      if (e.target && e.target.getAttribute('name') === 'id') refresh();
    });
    window.addEventListener('popstate', refresh);
    var lastHref = location.href;
    setInterval(function() {
      if (location.href !== lastHref) {
        lastHref = location.href;
        refresh();
      }
    }, 500);
  }

  /* ---- BOOT ---- */
  setTimeout(function() {
    var listenersStarted = false;
    var tiersLoaded = false;

    var path = location.pathname.split('?')[0];
    if (path.indexOf('/products/') !== -1) {
      fetch(path + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          productJsonCache = data.variants || [];
          var vid = getVariantId();
          if (vid) {
            for (var i = 0; i < productJsonCache.length; i++) {
              if (String(productJsonCache[i].id) === String(vid)) {
                var pi = document.querySelector('product-info');
                if (pi) pi.dataset.variantPrice = productJsonCache[i].price;
                break;
              }
            }
          }
        })
        .catch(function() {});
    }

    var poll = setInterval(function() {
      if (!isAPIReady()) return;

      if (!tiersLoaded) {
        tiersLoaded = true;
        setTimeout(function() { discoverTiers(); }, 100);
      }

      if (!listenersStarted) {
        listenersStarted = true;
        startVariantListeners();
        clearInterval(poll);
      }
    }, 50);

    setTimeout(function() { clearInterval(poll); }, 10000);
  }, 0);

})();
